import { VoidCallback } from '@deqo/foundation';
import React, { useCallback } from 'react';
import styled from 'styled-components';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { Button, Colors, usePrompt } from '../../../ui';
import { useResolve } from '../../Container';
import { ButtonStrip, Copy, Flexer, Title } from '../../dashboard/elements/LayoutElements';
import { Popup, PopupProps } from '../../popups/Popup';
import { lockSetLayout } from '../commands/ComponentCommands';

const IconFrame = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    border-radius: .5rem;
    width: 3rem;
    height: 3rem;
    background: whitesmoke;
    border: solid .0625rem ${Colors.border};

    svg {
        flex: 0 0 auto;
        color: ${Colors.primary};
        width: 2rem;
        height: 2rem;
    }
`;

export const lockLayoutPopup = () => ({ ui: LockLayoutPopup });

export const LockLayoutAlert = ({ onClose }: { onClose: VoidCallback }) => {

    const dispatch = useResolve(CommandDispatcher);
    const onRespond = useCallback((lock?: boolean) => {
        if (lock) {
            dispatch(lockSetLayout, [true]);
        }
        onClose();
    }, [onClose]);

    return <Flexer flex="column" center gap="1" padding="2">
        <Title size="lg" flush>Lock your layout?</Title>
        <Copy flush>
            Some layout elements on your board are not locked.
            Do you want to lock the layout to stop your participants moving stuff around by mistake?
        </Copy>
        <ButtonStrip align="center">
            <Button variant="primary" onAction={() => onRespond(true)}>Yes, lock the layout</Button>
            <Button variant="common" onAction={() => onRespond(false)}>No, it&apos;s fine</Button>
        </ButtonStrip>
    </Flexer>;
};

export const LockLayoutPopup = React.memo<PopupProps>(({ action, dismiss }) => {

    const promptRef = usePrompt({
        ignoreEnter: true,
        onAction: dismiss,
    });

    return <Popup ref={promptRef} w={32}>
        <Flexer flex="column" center gap="1" padding="1">
            <Title size="lg" flush>Lock your layout?</Title>
            <Copy flush>
                Some layout elements on your board are not locked.
                Do you want to lock the layout before you begin?
            </Copy>
            <ButtonStrip align="center">
                <Button variant="primary">Yes, lock the layout</Button>
                <Button variant="common">No, it&apos;s fine</Button>
            </ButtonStrip>
            {/* <DropButton>
                <Icon src="deqo://icons/deqo/design-lock-layout" size="2" />
                <Copy flush>Yes, lock the layout.</Copy>
            </DropButton>
            <DropButton>
                <IconFrame>
                    <Icon src="deqo://icons/hero/arrow-right" />
                </IconFrame>
                <Copy flush>No, leave it alone!</Copy>
            </DropButton> */}
        </Flexer>
    </Popup>;
});
